/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sp } from './Sp';

class ShopDriverWithdraw extends Sp {
    constructor() {
        super();
        this.baseUrl += '/shopDriverWithdraw';
    }

    data({ withdrawApplySn, driverName, driverMobile, withdrawType, withdrawStatus, currentPage, pageSize } = {}) {
        return super.get('/data', {
            withdrawApplySn,
            driverName,
            driverMobile,
            withdrawType,
            withdrawStatus,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/get', { id });
    }

    audit({ id, paymentAmount, paymentVoucher, auditStatus, auditRemarks } = {}) {
        const paymentVoucherStr = paymentVoucher
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/audit', {
            id,
            paymentAmount,
            paymentVoucher: paymentVoucherStr,
            auditStatus,
            auditRemarks,
        });
    }
}

export default new ShopDriverWithdraw();
export { ShopDriverWithdraw };
